module.exports = __webpack_public_path__ + "img/link.2ab19cad.png";